import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomePage from "./HomePage";
import PolicyPage from "./PolicyPage";
import FeedbackPage from "./FeedbackPage";
import Error404 from "./ErrorPage";
import GetStarted from "./GetStarted";
import { Helmet, HelmetProvider } from "react-helmet-async";

export const AppRoutes = () => {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/getstarted" element={<GetStarted />} />
          <Route path="/faq" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};
